module.exports = __webpack_public_path__ + "media/images/branding/coco_logo_svg_2-3cb86563799e96fd975958a95c0cf80e.svg";